import { FundingSource } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/FundingSource";
import {
  INestedCheckboxOption,
  NestedCheckboxes,
} from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/NestedCheckboxes/NestedCheckboxes";
import { useNestedCheckboxes } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/NestedCheckboxes/useNestedCheckboxes";
import { OwFFormFieldValueType } from "@faire/retailer-visitor-shared/components/OpenWithFaire/OpenWithFaireApplication/OwFFormField";
import React, { FC } from "react";

interface IProps {
  onChange: (newValue: OwFFormFieldValueType) => void;
  options: INestedCheckboxOption[];
  value: string | undefined;
}

export const RootNestedCheckbox: FC<IProps> = ({
  onChange,
  options,
  value,
}) => {
  const initialCheckedBoxes = new Set(value?.split(DELIMITER));
  const { checkedFields, toggle, getCheckedKeys } = useNestedCheckboxes(
    options,
    initialCheckedBoxes
  );

  const onToggle = (key: FundingSource) => {
    toggle(key);
    // onChange triggers a re-render
    onChange(getCheckedKeys(options).join(DELIMITER));
  };

  return (
    <NestedCheckboxes
      options={options}
      checkedFields={checkedFields.current}
      toggle={onToggle}
    />
  );
};

const DELIMITER = ", ";
